<ng-diagram-base-edge [edge]="edge()" [strokeWidth]="4" [stroke]="'grey'">
  <ng-diagram-base-edge-label id="test-label" [positionOnEdge]= "0.5">
      <div class="avs-edge-label"
            [style.color] ="edge().data.type == 'fix' ? 'black' : edge().data.type == 'neutral' ? 'grey' : edge().data.type == 'pos'? 'green' : 'red'">
        {{ edge().data.label }}
      </div>
    </ng-diagram-base-edge-label>
</ng-diagram-base-edge>
